import React from 'react';
import styles from '../index.module.scss';
import { Controller, useFormContext } from 'react-hook-form';
import useDiagnosisOptions from '../../../../../../../Intake/ClinicalInformation/useDiagnosisOptions';
import { FormControl } from '@mui/material';
import MultipleSelect from '../../../../../../../Inputs/MultipleSelect';
import classNames from 'classnames';
import { ReactComponent as ExpandMoreIcon } from '../../../../../../../../assets/icons/patientProfileIcons/expandMoreIcon.svg';
import { isEmpty } from 'lodash';

const DiagnosisField = ({ required }: { required?: boolean }) => {
  const { control, getValues } = useFormContext();
  const diagnosisOptions = useDiagnosisOptions() ?? [];

  return (
    <FormControl className={'w-full'} required={required}>
      <Controller
        name="diagnosis"
        control={control}
        render={({ field }) => {
          return (
            <MultipleSelect
              {...field}
              selected={getValues('diagnosis') || []}
              options={diagnosisOptions}
              required={required}
              displayEmpty={true}
              renderValue={(value) => (
                <div
                  className={classNames(styles.selectValue, {
                    [styles.placeholder]: isEmpty(value),
                  })}
                >
                  {(value as Array<string>)?.length
                    ? (value as Array<string>)
                        ?.map((diagnosisCode: string) => {
                          const foundDiagnosis = diagnosisOptions?.find(
                            (option) => option?.value === diagnosisCode,
                          );
                          return foundDiagnosis?.label;
                        })
                        .join(', ')
                    : 'Select diagnosis'}
                </div>
              )}
              label="Diagnosis"
              selectClassName={styles.inputField}
              iconClassName={styles.selectIcon}
              wrapperClassName={classNames(
                styles.inputWrapper,
                styles.selectWrapper,
                styles.largeInputWrapper,
              )}
              width="100%"
              customIcon={ExpandMoreIcon}
            />
          );
        }}
        rules={{
          required: {
            value: required ?? false,
            message: 'Diagnosis is required',
          },
        }}
      />
    </FormControl>
  );
};

export default DiagnosisField;
